import {
    tableBodyClasses,
    tableCellClasses,
    tableClasses,
    tableHeadClasses,
    tablePaginationClasses,
    tableRowClasses,
    toolbarClasses,
} from '@mui/material'
import { spacing } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1TableReduxStyles: moduleStyleType = {
    skeletonRow: {
        paddingTop: 2,
        paddingBottom: 2,
        flex: 1,
        width: '100%',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'border.subtle',
    },
    skeleton: {
        width: '100%',
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'grey.150',
        borderTopLeftRadius: C1BorderRadius.large,
        borderTopRightRadius: C1BorderRadius.large,
        boxShadow: '0px 2px 4px -2px #1018281A',
    },
    table: {
        [`&.${tableClasses.root}`]: {
            display: 'grid',
            minWidth: '100%',
            maxWidth: '100%',

            [`& .${tableHeadClasses.root}`]: {
                display: 'contents',
                [`& .${tableRowClasses.root}`]: {
                    display: 'contents',
                    borderTopLeftRadius: C1BorderRadius.large,
                    borderTopRightRadius: C1BorderRadius.large,

                    [`& .${tableCellClasses.stickyHeader}`]: {
                        display: 'flex',
                        flex: 1,
                        width: '100%',
                        zIndex: '3',
                        backgroundColor: 'background.default',
                        borderBottom: 1,
                        borderBottomStyle: 'solid',
                        borderBottomColor: 'grey.150',
                        padding: 1,
                        minHeight: '40px',
                        alignItems: 'center',

                        '&:first-of-type': {
                            paddingLeft: 2,
                        },
                    },
                },
            },
            [`& .${tableBodyClasses.root}`]: {
                display: 'contents',
                [`& .${tableRowClasses.root}`]: {
                    display: 'contents',
                    [`& .${tableCellClasses.root}`]: {
                        minHeight: '40px',
                    },
                    '&:hover': {
                        [`& .${tableCellClasses.root}`]: {
                            borderTopColor: 'grey.150',
                        },
                    },
                    '&:last-of-type': {
                        [`& .${tableCellClasses.root}`]: {
                            borderBottom: 0,
                        },
                    },
                },
            },
        },
    },
    sortIcon: {
        ml: 1,
        opacity: 0.2,
        '&:hover': {
            opacity: 0.6,
        },
    },
    sortIconActive: {
        opacity: 1,
    },
    reloadContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: 1,
        paddingLeft: 2,
        paddingRight: 2,
        backgroundColor: 'background.default',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'grey.150',
        flexShrink: 0,
    },
    tablePagination: {
        minHeight: '48px',
        [`&.${tablePaginationClasses.root}`]: {
            [`& .${tablePaginationClasses.toolbar}`]: {
                minHeight: 0,
            },
        },
    },
    sticky: {
        position: 'sticky',
        right: 0,
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'border.subtle',
        zIndex: '2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
    },
    metadata: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-end',
    },
    cell: {
        display: 'flex',
        flex: 1,
        width: '100%',
        alignItems: 'center',
        backgroundColor: 'background.default',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'border.subtle',
        padding: 1,
        fontWeight: 450,

        '&:first-of-type': {
            paddingLeft: 2,
        },
    },
    errorCell: {
        position: 'relative',

        '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: spacing.xs,
            bottom: 0,
            backgroundColor: 'error.main',
        },
    },
    paginationWrapper: {
        minHeight: '48px',
        backgroundColor: 'background.default',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 2,
        border: 1,
        borderTop: 0,
        borderStyle: 'solid',
        borderColor: 'grey.150',
        borderBottomLeftRadius: C1BorderRadius.large,
        borderBottomRightRadius: C1BorderRadius.large,
        boxShadow: '0px 2px 4px -2px #1018281A',

        [`& .${tablePaginationClasses.root}`]: {
            marginLeft: 'auto',

            [`& .${toolbarClasses.root}`]: {
                minHeight: 0,
            },
        },
    },
    warningCell: {
        position: 'relative',

        '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: spacing.xs,
            bottom: 0,
            backgroundColor: 'warning.main',
        },
    },
    groupHeader: {
        position: 'sticky',
        top: '40px',
        zIndex: 3,
        backgroundColor: 'primary.extraLight',
        borderBottom: '1px solid',
        borderBottomColor: 'grey.100',
    },
}
